function Footer() {
  return (
    <footer className="mt-auto row">
      <a
        className="col-6 pageLinks text-center"
        href="https://github.com/josh2100"
        target="_blank"
        rel="noreferrer"
      >
        GitHub
      </a>

      <a
        className="col-6 pageLinks text-center"
        href="https://www.linkedin.com/in/joshua-schermann-91621734/"
        target="_blank"
        rel="noreferrer"
      >
        LinkedIn
      </a>
    </footer>
  );
}

export default Footer;
